exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host {\n  display: block;\n  height: 1.5rem;\n  position: relative; }\n\n.form-control-xs {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  border: none !important;\n  border-radius: 3px !important; }\n", ""]);

